export default {
    cantico: {
      title: 'Il Cantico delle Creature',
      subtitle: 'di San Francesco d\'Assisi',
      headerOriginal: 'Lingua originale del 1225',
      headerTranslations: 'Versione in francese',
      text: `Très-Haut, tout-puissant, Seigneur, à toi appartiennent
la louange, la gloire, l'honneur et toutes les
bénédictions. À toi seul, Très-Haut, elles reviennent, et
nul n'est digne de toi.

Loué sois-Tu, mon Seigneur, pour toutes les créatures,
et particulièrement pour le Soleil, qui nous apporte le
jour, beau et rayonnant d'une grande splendeur : de Toi,
Très-Haut, il est porteur de sens.

Loué sois-Tu, mon Seigneur, pour la Lune et les Étoiles :
dans les cieux, Tu les as formées, claires, belles et
précieuses.

Loué sois-tu, mon Seigneur, par Frère Vent, par l'Air, les
Nuages, le Ciel pur et tous les éléments grâce auxquels
Tu soutiens Tes créatures.

Loué sois-tu, mon Seigneur, par Sœur Eau, si utile,
humble, précieuse et pure.

Loué sois-tu, mon Seigneur, par Frère Feu, par qui Tu
illumines la nuit : il est robuste, beau, fort et joyeux.

Louange à toi, Seigneur, pour notre Terre Mère, qui nous
nourrit et nous gouverne, et qui produit une multitude
de fruits, de fleurs et d'herbes multicolores.

Loué sois-tu, Seigneur, pour ceux qui pardonnent par
amour pour toi et endurent la maladie et la souffrance.
Heureux ceux qui les endurent en paix, car par toi ils
seront couronnés.

Loué sois-tu, Seigneur, pour notre sœur, la Mort
corporelle, à laquelle nul ne peut échapper. Malheur à
ceux qui meurent en état de péché mortel. Heureux
ceux qui sont dans ta volonté, car la mort ne leur fera
aucun mal.

Louez et bénissez le Seigneur, rendez-lui grâce et servez-
le avec une grande humilité.`
    }
}